import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/community/page.tsx");
